/**
 * @generated SignedSource<<cf2905c95e7ff648218c6ff114f522a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SyntheticActionItemGroupsListChangeDueDateMutation$variables = {
  dueDate?: any | null;
  noteBlockId: string;
};
export type SyntheticActionItemGroupsListChangeDueDateMutation$data = {
  readonly changeActionItemDueDate: {
    readonly updatedBlock: {
      readonly dueDate: string | null;
      readonly id: string;
    };
  } | null;
};
export type SyntheticActionItemGroupsListChangeDueDateMutation$rawResponse = {
  readonly changeActionItemDueDate: {
    readonly updatedBlock: {
      readonly dueDate: string | null;
      readonly id: string;
    };
  } | null;
};
export type SyntheticActionItemGroupsListChangeDueDateMutation = {
  rawResponse: SyntheticActionItemGroupsListChangeDueDateMutation$rawResponse;
  response: SyntheticActionItemGroupsListChangeDueDateMutation$data;
  variables: SyntheticActionItemGroupsListChangeDueDateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dueDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteBlockId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dueDate",
        "variableName": "dueDate"
      },
      {
        "kind": "Variable",
        "name": "noteBlockId",
        "variableName": "noteBlockId"
      }
    ],
    "concreteType": "ChangeActionItemDueDate",
    "kind": "LinkedField",
    "name": "changeActionItemDueDate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteBlock",
        "kind": "LinkedField",
        "name": "updatedBlock",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dueDate",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SyntheticActionItemGroupsListChangeDueDateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SyntheticActionItemGroupsListChangeDueDateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "051442559d721fb19e6a137b3bb5e9fa",
    "id": null,
    "metadata": {},
    "name": "SyntheticActionItemGroupsListChangeDueDateMutation",
    "operationKind": "mutation",
    "text": "mutation SyntheticActionItemGroupsListChangeDueDateMutation(\n  $noteBlockId: ID!\n  $dueDate: Date\n) {\n  changeActionItemDueDate(noteBlockId: $noteBlockId, dueDate: $dueDate) {\n    updatedBlock {\n      id\n      dueDate\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8c95a78afa0072963367ed5553b3a3d2";

export default node;
